import { EmailVo } from "../VOs/email.vo";
import { IdentityDocumentVo } from "../VOs/identity-document.vo";
import { PhoneVo } from "../VOs/phone.vo";
import { PermissionGroup } from "./permission-group.model";
import { TenantGroup } from "./tenant-group.model";
import { Tenant } from "./tenant.model";
import { Token } from "./token.model";
import { VupConsoleVisualSettings } from "./vup-console-visual-settings.model";

export class User {
    id!: string;
    name!: string;
    userName!: string;
    profile!: string;
    role!: string;
    tenantGroupId!: number;
    tenantGroup?: TenantGroup;
    visualSettings?: VupConsoleVisualSettings;
    email?: EmailVo;
    phoneVerified!: boolean;

    image?: string | null;
    cpf?: string;
    responsibleId?: string;
    resaponsible?: User;

    tenantId?: number;
    businessUnitId?: number;
    occupationAreaId?: number;
    departmentId?: number;
    permissions?: PermissionGroup[];
    identityDocument?: IdentityDocumentVo;
    phone?: PhoneVo;
    active!: boolean;
    clockInUrl!: string;
    isOnline!: boolean;
    // propriedade de visualização
    tenant?: Tenant;
    hasRegisteredAuthority: boolean = false;
    profileApontamentos?: string;
    responsibleName?: string;
    isSelected!: boolean;
    nameInitials?: string;
    nameInitialsImage?: string;
    relatedEntityId?: number;
    changePasswordOnNextLogin!: boolean;

    static decrypt(hash: string): User | null {
        try {
            var json = atob(hash).replace('int_acc_', '');
            let user = <User>JSON.parse(json);

            if (!user)
                return null;

            return user;
        } catch (error) {
            return null;
        }
    }
}